module.exports = __webpack_public_path__ + "static/hero-b9e0cb0b2f1018be2e9eb70f2e7bc1be.jpg";